import axios, { AxiosInstance, AxiosError, AxiosHeaders } from 'axios';
import apiConfig from '../config/api';
import { getTelegramInitData } from '../utils/initData';

// Создание экземпляра axios
const apiClient: AxiosInstance = axios.create({
  baseURL: apiConfig.baseURL || '', // Если пусто, используем относительный путь
  timeout: apiConfig.timeout,
  headers: apiConfig.headers,
});

// Интерцептор запросов
apiClient.interceptors.request.use(
  (config) => {
    const initData = getTelegramInitData();
    if (initData) {
      const headers = config.headers ? new AxiosHeaders(config.headers) : new AxiosHeaders();
      headers.set('X-Telegram-Init-Data', initData);
      const e2eUserJson = import.meta.env.VITE_E2E_TEST_USER_JSON as string | undefined;
      if (e2eUserJson && e2eUserJson.trim()) {
        headers.set('X-Test-Telegram-User', e2eUserJson.trim());
      }
      config.headers = headers;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Интерцептор ответов
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.code === 'ECONNABORTED') {
      return Promise.reject(new Error('Превышено время ожидания ответа сервера. Попробуйте ещё раз.'));
    }
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        const data = error.response.data as { error?: { message?: string; code?: string } } | undefined;
        const backendMessage =
          typeof data?.error?.message === 'string' && data.error.message.trim()
            ? data.error.message
            : 'Не удалось подтвердить авторизацию Telegram. Откройте мини‑приложение из бота.';
        const err = new Error(backendMessage) as Error & { response?: typeof error.response };
        err.response = error.response;
        return Promise.reject(err);
      }
      return Promise.reject(error);
    }
    if (error.request) {
      return Promise.reject(new Error('Не удалось подключиться к серверу. Проверьте интернет‑соединение и попробуйте ещё раз.'));
    }
    return Promise.reject(error);
  }
);

export default apiClient;
